import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-tree-list",
  templateUrl: "./tree-list.component.html",
  styleUrls: ["./tree-list.component.css"]
})
export class TreeListComponent {
  @Input() dataSource: any[];
  @Input() columns: any[];
  @Input() keyExpr: string;
  @Input() parentIdExpr: string;
  @Input() height: number;
  @Input() columnAutoWidth = true;
  @Input() selectionMode = "none";

  @Output() cellPrepared = new EventEmitter<any>();
  @Output() rowClicked = new EventEmitter<any>();

  constructor() {}
}
